// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Navbar.css */
:root {
  --green: #7ED321;
  --blue: #2C3E50;
  --text-light: rgba(255, 255, 255, 0.9);
  --text-muted: rgba(255, 255, 255, 0.7);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.nav {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 80px);
  max-width: 1240px;
  z-index: 1000;
  pointer-events: none;
}

.nav-container {
  padding: 8px 24px;
  background: rgba(38, 48, 61, 0.95); /* Semi-transparent dark background */
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: saturate(150%);
  -webkit-backdrop-filter: blur(20px) saturate(150%);
  pointer-events: auto;
  position: relative;
  z-index: 1000;
}

/* Add subtle gradient overlay */
.nav-container::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.03) 0%,
    rgba(255, 255, 255, 0.01) 50%,
    rgba(0, 0, 0, 0.03) 100%
  );
  border-radius: 16px;
  pointer-events: none;
}

.nav-logo {
  height: 44px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  text-decoration: none;
  position: relative;
  z-index: 1;
  order: 1; /* Logo first (left side) */
}

.nav-logo img {
  height: 100%;
  width: auto;
  transition: transform 0.3s ease, filter 0.3s ease;
}

.nav-logo:hover img {
  transform: scale(1.05);
  filter: brightness(1.15) drop-shadow(0 0 8px rgba(126, 211, 33, 0.4));
}

/* Mobile hamburger */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1002;
  position: relative;
  order: 1; /* Hamburger first on mobile */
}

.hamburger span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.hamburger.active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

.nav-center {
  display: flex;
  gap: 36px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
  order: 2; /* Middle on desktop */
}

.nav-center a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  transition: all 0.3s ease;
  position: relative;
  padding: 8px 4px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.nav-center a::after {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--green), #4ade80);
  transition: width 0.4s ease;
  box-shadow: 0 0 8px rgba(126, 211, 33, 0.5);
}

.nav-center a:hover {
  color: rgba(255, 255, 255, 1);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
}

.nav-center a:hover::after,
.nav-center a.active::after {
  width: 100%;
}

.nav-center a.active {
  color: rgba(255, 255, 255, 1);
}

/* Mobile-only Apply Now button inside menu */
.apply-btn-mobile {
  display: none;
}

.nav-right {
  position: relative;
  z-index: 1;
  order: 3; /* Apply Now button last on desktop */
}

.nav-right .apply-btn {
  background: linear-gradient(135deg, var(--green) 0%, #6BC91A 100%);
  border: none;
  padding: 10px 22px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 15px;
  box-shadow: 
    0 10px 25px rgba(126, 211, 33, 0.4),
    0 0 0 1px rgba(126, 211, 33, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  color: #000;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  display: inline-block;
}

.nav-right .apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 15px 35px rgba(126, 211, 33, 0.5),
    0 0 0 1px rgba(126, 211, 33, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  filter: brightness(1.1);
}

.nav-right .apply-btn:active {
  transform: translateY(-1px);
}

/* ===== Responsive ===== */
@media (max-width: 1024px) {
  .nav {
    width: calc(100% - 40px);
    top: 15px;
  }
  
  /* Hide Apply Now button on tablet */
  .nav-right {
    display: none;
  }
  
  /* Show hamburger and reorder */
  .hamburger {
    display: flex;
  }
  
  /* Logo stays visible on right */
  .nav-logo {
    order: 3;
    margin-left: auto;
  }
  
  .nav-center {
    position: fixed;
    top: 0;
    right: -100%;
    width: 80%;
    max-width: 320px;
    height: 100vh;
    background: rgba(52, 67, 83, 0.98);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    flex-direction: column;
    align-items: flex-start;
    padding: 100px 30px 40px;
    transition: right 0.4s ease;
    box-shadow: 
      -5px 0 30px rgba(0, 0, 0, 0.3),
      inset 1px 0 0 rgba(255, 255, 255, 0.1);
    z-index: 1001;
    gap: 0;
    margin: 0;
  }

  .nav-center.active {
    right: 0;
  }

  .nav-center a {
    font-size: 18px;
    padding: 14px 0;
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .nav-center a::after {
    display: none;
  }
  
  /* Show Apply Now button in mobile menu */
  .apply-btn-mobile {
    display: block !important;
    background: linear-gradient(135deg, var(--green) 0%, #6BC91A 100%);
    border: none;
    padding: 14px 24px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 16px;
    box-shadow: 
      0 10px 25px rgba(126, 211, 33, 0.4),
      0 0 0 1px rgba(126, 211, 33, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;
    color: #000 !important;
    white-space: nowrap;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    text-decoration: none;
    text-align: center;
    margin-top: 24px;
    border-bottom: none !important;
  }
  
  .apply-btn-mobile:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 15px 35px rgba(126, 211, 33, 0.5),
      0 0 0 1px rgba(126, 211, 33, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
    filter: brightness(1.1);
  }
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  /* Hide desktop Apply Now button */
  .nav-right {
    display: none;
  }
  
  /* Logo on the right */
  .nav-logo {
    order: 3;
    margin-left: auto;
  }

  .nav-center {
    position: fixed;
    top: 0;
    right: -100%;
    width: 80%;
    max-width: 320px;
    height: 100vh;
    background: rgba(52, 67, 83, 0.98);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    flex-direction: column;
    align-items: flex-start;
    padding: 100px 30px 40px;
    transition: right 0.4s ease;
    box-shadow: 
      -5px 0 30px rgba(0, 0, 0, 0.3),
      inset 1px 0 0 rgba(255, 255, 255, 0.1);
    z-index: 1001;
  }

  .nav-center.active {
    right: 0;
  }

  .nav-center a {
    font-size: 18px;
    padding: 12px 0;
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .nav-center a::after {
    display: none;
  }
  
  /* Show Apply Now button in mobile menu */
  .apply-btn-mobile {
    display: block !important;
    background: linear-gradient(135deg, var(--green) 0%, #6BC91A 100%);
    padding: 14px 24px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 16px;
    box-shadow: 
      0 10px 25px rgba(126, 211, 33, 0.4),
      0 0 0 1px rgba(126, 211, 33, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
    color: #000 !important;
    text-align: center;
    margin-top: 24px;
    border-bottom: none !important;
  }
}

@media (max-width: 480px) {
  .nav {
    top: 10px;
    width: calc(100% - 30px);
  }
  .nav-container {
    padding: 6px 15px;
  }
  .nav-logo {
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC,EAAE,qCAAqC;EACzE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;uCAEqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,kDAAkD;EAClD,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAE,2BAA2B;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,QAAQ,EAAE,8BAA8B;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAE,sBAAsB;AAClC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yDAAyD;EACzD,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAE,qCAAqC;AACjD;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf;;;0CAGwC;EACxC,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B;;;0CAGwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,wBAAwB;IACxB,SAAS;EACX;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,2BAA2B;IAC3B,mCAAmC;IACnC,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B;;4CAEwC;IACxC,aAAa;IACb,MAAM;IACN,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,iDAAiD;EACnD;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,yBAAyB;IACzB,kEAAkE;IAClE,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf;;;4CAGwC;IACxC,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;IACzC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B;;;4CAGwC;IACxC,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA,kCAAkC;EAClC;IACE,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,2BAA2B;IAC3B,mCAAmC;IACnC,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B;;4CAEwC;IACxC,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,iDAAiD;EACnD;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,yBAAyB;IACzB,kEAAkE;IAClE,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf;;;4CAGwC;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,SAAS;IACT,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* src/components/Navbar.css */\n:root {\n  --green: #7ED321;\n  --blue: #2C3E50;\n  --text-light: rgba(255, 255, 255, 0.9);\n  --text-muted: rgba(255, 255, 255, 0.7);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.nav {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: calc(100% - 80px);\n  max-width: 1240px;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.nav-container {\n  padding: 8px 24px;\n  background: rgba(38, 48, 61, 0.95); /* Semi-transparent dark background */\n  border-radius: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.3),\n    0 0 0 1px rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: saturate(150%);\n  -webkit-backdrop-filter: blur(20px) saturate(150%);\n  pointer-events: auto;\n  position: relative;\n  z-index: 1000;\n}\n\n/* Add subtle gradient overlay */\n.nav-container::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.03) 0%,\n    rgba(255, 255, 255, 0.01) 50%,\n    rgba(0, 0, 0, 0.03) 100%\n  );\n  border-radius: 16px;\n  pointer-events: none;\n}\n\n.nav-logo {\n  height: 44px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  position: relative;\n  z-index: 1;\n  order: 1; /* Logo first (left side) */\n}\n\n.nav-logo img {\n  height: 100%;\n  width: auto;\n  transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.nav-logo:hover img {\n  transform: scale(1.05);\n  filter: brightness(1.15) drop-shadow(0 0 8px rgba(126, 211, 33, 0.4));\n}\n\n/* Mobile hamburger */\n.hamburger {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 21px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1002;\n  position: relative;\n  order: 1; /* Hamburger first on mobile */\n}\n\n.hamburger span {\n  display: block;\n  height: 3px;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.hamburger.active span:nth-child(1) {\n  transform: translateY(9px) rotate(45deg);\n}\n\n.hamburger.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.active span:nth-child(3) {\n  transform: translateY(-9px) rotate(-45deg);\n}\n\n.nav-center {\n  display: flex;\n  gap: 36px;\n  margin: 0 auto;\n  padding: 0 20px;\n  position: relative;\n  z-index: 1;\n  order: 2; /* Middle on desktop */\n}\n\n.nav-center a {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  position: relative;\n  padding: 8px 4px;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.nav-center a::after {\n  content: '';\n  position: absolute;\n  bottom: 4px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, var(--green), #4ade80);\n  transition: width 0.4s ease;\n  box-shadow: 0 0 8px rgba(126, 211, 33, 0.5);\n}\n\n.nav-center a:hover {\n  color: rgba(255, 255, 255, 1);\n  text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);\n}\n\n.nav-center a:hover::after,\n.nav-center a.active::after {\n  width: 100%;\n}\n\n.nav-center a.active {\n  color: rgba(255, 255, 255, 1);\n}\n\n/* Mobile-only Apply Now button inside menu */\n.apply-btn-mobile {\n  display: none;\n}\n\n.nav-right {\n  position: relative;\n  z-index: 1;\n  order: 3; /* Apply Now button last on desktop */\n}\n\n.nav-right .apply-btn {\n  background: linear-gradient(135deg, var(--green) 0%, #6BC91A 100%);\n  border: none;\n  padding: 10px 22px;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 15px;\n  box-shadow: \n    0 10px 25px rgba(126, 211, 33, 0.4),\n    0 0 0 1px rgba(126, 211, 33, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  color: #000;\n  white-space: nowrap;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n  display: inline-block;\n}\n\n.nav-right .apply-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: \n    0 15px 35px rgba(126, 211, 33, 0.5),\n    0 0 0 1px rgba(126, 211, 33, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  filter: brightness(1.1);\n}\n\n.nav-right .apply-btn:active {\n  transform: translateY(-1px);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 1024px) {\n  .nav {\n    width: calc(100% - 40px);\n    top: 15px;\n  }\n  \n  /* Hide Apply Now button on tablet */\n  .nav-right {\n    display: none;\n  }\n  \n  /* Show hamburger and reorder */\n  .hamburger {\n    display: flex;\n  }\n  \n  /* Logo stays visible on right */\n  .nav-logo {\n    order: 3;\n    margin-left: auto;\n  }\n  \n  .nav-center {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 80%;\n    max-width: 320px;\n    height: 100vh;\n    background: rgba(52, 67, 83, 0.98);\n    backdrop-filter: blur(30px);\n    -webkit-backdrop-filter: blur(30px);\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 100px 30px 40px;\n    transition: right 0.4s ease;\n    box-shadow: \n      -5px 0 30px rgba(0, 0, 0, 0.3),\n      inset 1px 0 0 rgba(255, 255, 255, 0.1);\n    z-index: 1001;\n    gap: 0;\n    margin: 0;\n  }\n\n  .nav-center.active {\n    right: 0;\n  }\n\n  .nav-center a {\n    font-size: 18px;\n    padding: 14px 0;\n    width: 100%;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .nav-center a::after {\n    display: none;\n  }\n  \n  /* Show Apply Now button in mobile menu */\n  .apply-btn-mobile {\n    display: block !important;\n    background: linear-gradient(135deg, var(--green) 0%, #6BC91A 100%);\n    border: none;\n    padding: 14px 24px;\n    border-radius: 999px;\n    font-weight: 700;\n    font-size: 16px;\n    box-shadow: \n      0 10px 25px rgba(126, 211, 33, 0.4),\n      0 0 0 1px rgba(126, 211, 33, 0.3),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n    transition: all 0.3s ease;\n    cursor: pointer;\n    color: #000 !important;\n    white-space: nowrap;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    text-decoration: none;\n    text-align: center;\n    margin-top: 24px;\n    border-bottom: none !important;\n  }\n  \n  .apply-btn-mobile:hover {\n    transform: translateY(-2px);\n    box-shadow: \n      0 15px 35px rgba(126, 211, 33, 0.5),\n      0 0 0 1px rgba(126, 211, 33, 0.4),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n    filter: brightness(1.1);\n  }\n}\n\n@media (max-width: 768px) {\n  .hamburger {\n    display: flex;\n  }\n\n  /* Hide desktop Apply Now button */\n  .nav-right {\n    display: none;\n  }\n  \n  /* Logo on the right */\n  .nav-logo {\n    order: 3;\n    margin-left: auto;\n  }\n\n  .nav-center {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 80%;\n    max-width: 320px;\n    height: 100vh;\n    background: rgba(52, 67, 83, 0.98);\n    backdrop-filter: blur(30px);\n    -webkit-backdrop-filter: blur(30px);\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 100px 30px 40px;\n    transition: right 0.4s ease;\n    box-shadow: \n      -5px 0 30px rgba(0, 0, 0, 0.3),\n      inset 1px 0 0 rgba(255, 255, 255, 0.1);\n    z-index: 1001;\n  }\n\n  .nav-center.active {\n    right: 0;\n  }\n\n  .nav-center a {\n    font-size: 18px;\n    padding: 12px 0;\n    width: 100%;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .nav-center a::after {\n    display: none;\n  }\n  \n  /* Show Apply Now button in mobile menu */\n  .apply-btn-mobile {\n    display: block !important;\n    background: linear-gradient(135deg, var(--green) 0%, #6BC91A 100%);\n    padding: 14px 24px;\n    border-radius: 999px;\n    font-weight: 700;\n    font-size: 16px;\n    box-shadow: \n      0 10px 25px rgba(126, 211, 33, 0.4),\n      0 0 0 1px rgba(126, 211, 33, 0.3),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n    color: #000 !important;\n    text-align: center;\n    margin-top: 24px;\n    border-bottom: none !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav {\n    top: 10px;\n    width: calc(100% - 30px);\n  }\n  .nav-container {\n    padding: 6px 15px;\n  }\n  .nav-logo {\n    height: 36px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
